<template>

    <v-app-bar app elevate-on-scroll dark>

        <template v-if="backTo">
            <v-btn icon :to="backTo">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            Torna indietro...
        </template>

        <template v-else>
            <v-btn :ripple="false" text tile to="/" class="pa-0">
                <v-img src="../assets/icon_white.png" max-height="30" max-width="30" class="mr-2"></v-img>
                <strong>IS</strong>App
                <!--<small class="grey&#45;&#45;text ml-2">Ver. {{VERSION}}</small>-->
            </v-btn>
        </template>

        <v-spacer></v-spacer>

        <slot name="action"></slot>

        <v-btn icon @click="notifPath">
            <v-badge v-model="unreadNotify" overlap dot value="1" color="deep-orange darken-4">
                <v-icon>mdi-bell-outline</v-icon>
            </v-badge>
        </v-btn>

        <v-menu v-if="!hideMenu" left bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <action-menu :items="accountMenu" @echo="echo"></action-menu>
        </v-menu>

    </v-app-bar>

</template>

<script>

    import {mapGetters, mapActions, mapState, mapMutations} from 'vuex'
    import actionMenu from './actionMenu';

    export default {
        name: "app-bar",
        props: {
            hideMenu: {
                type: Boolean,
                default: false
            },
            menu: {
                type: Object | Array,
            },
            backTo: Object,
        },
        components: {
            actionMenu
        },
        beforeMount() {
            if (typeof this.menu !== 'undefined' && this.menu.length > 0) {
                this.menu.forEach(m => {
                    this.accountMenu.push(m)
                })
            }
        },
        data: () => ({
            accountMenu: [
                {text: 'Profilo', icon: 'mdi-account', to: '/member'},
                //{text: 'Impostazioni', to: '/settings', icon: 'mdi-cogs'},
                {text: 'Esci', icon: 'mdi-exit-to-app', action: 'logout'},
            ],
        }),
        computed: {
            ...mapState([
                'VERSION',
                'unreadNotify'
            ]),
            ...mapGetters([
                'isLoggedIn',
            ]),
        },
        methods: {
            ...mapMutations([
                'setUnreadNotify'
            ]),
            ...mapActions([
                '_Logout'
            ]),
            echo(action) {
                if (action === 'logout') {
                    this._Logout();
                }
                this.$emit(action)
            },
            notifPath() {
                this.$router.push({name: 'notifications', params: {back_to: this.$route}})
            },
        }
    }
</script>

<style scoped>
    .top-menu-bg {
        background-image: linear-gradient(90deg, #ff2b44, #ff5333);
        animation: bganimation 7s infinite;
        background-size: 200% 200%;
        color: white !important;
    }
</style>